import { Button } from "@/components/ui/button";
import { useLanguage } from "@/contexts/LanguageContext";

interface HeroSectionProps {
  onGetStarted: () => void;
}

/**
 * Landing V2 — Hero. Single column, centered. One CTA only.
 */
export function HeroSection({ onGetStarted }: HeroSectionProps) {
  const { t } = useLanguage();

  return (
    <section className="relative px-6 flex items-center justify-center min-h-[calc(100vh-7rem)]">
      {/* Subtle ambient glow */}
      <div aria-hidden className="pointer-events-none absolute inset-0 overflow-hidden">
        <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-[500px] h-[500px] rounded-full bg-gradient-to-br from-[hsl(var(--gradient-start))]/10 to-[hsl(var(--gradient-end))]/8 blur-[110px]" />
      </div>

      <div className="relative max-w-3xl mx-auto text-center space-y-6">
        <h1 className="text-4xl sm:text-5xl md:text-6xl font-semibold text-foreground leading-[1.1] tracking-tight">
          {t("landing.hero.headline")}
        </h1>

        <p className="text-base sm:text-lg text-muted-foreground max-w-xl mx-auto leading-relaxed">
          {t("landing.hero.subheadline")}
        </p>

        <div className="pt-2 flex justify-center">
          <Button
            size="lg"
            onClick={onGetStarted}
            className="min-h-[48px] px-10 text-base"
          >
            {t("landing.hero.cta")}
          </Button>
        </div>
      </div>
    </section>
  );
}
